module.exports = __webpack_public_path__ + "img/profile.ecf9d7f6.svg";